import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import UserContext from '../tools/contextLib'
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import { connect } from 'react-redux';

class GenDormAccess extends Component {
    static displayName = GenDormAccess.name;
    //This page is not in use
    constructor(props) {
        super(props);
        this.state = {
            browser: `${browserName}${browserVersion}`,
            ip: "",
            returnable: this.props.reduxData.userInfo,
            loading: false,
            username: this.props.reduxData.userInfo.username,
            permissionFlag: true,
        }
        this.testPermission();
    }

    componentDidMount() {

    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: this.props.reduxData.userInfo,
            loading: false,
            username: this.props.reduxData.userInfo.username
        });
        this.testPermission();
        //var dept = this.props.reduxData.userInfo.level.pk 
        //dept = dept.substring(0, dept.indexOf('-') - 1); 
    }

    async getUserIP() {
        const response = await axios.get('https://geolocation-db.com/json/');
        this.setState({
            IP: response.data.IPv4
        }, () => {
            this.testPermission();
             });
    }

    //async recordComingHere() { 
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "0",
    //        department: this.props.reduxData.userInfo.level.pk,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.IP,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "0"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    render() {
        if(this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <h1>General Dorm Hall Access</h1>
                    )}
                </UserContext.Consumer>
            );    
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(GenDormAccess);